var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Workflow-Data-Table-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Workflow Data Table 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.25H3a3 3 0 0 0 -3 3v11.5a3 3 0 0 0 3 3h18a3 3 0 0 0 3 -3V6.25a3 3 0 0 0 -3 -3ZM7 18.75H3a1 1 0 0 1 -1 -1v-3h5Zm0 -6H2v-4h5Zm5 6H9v-4h3Zm0 -6H9v-4h3Zm5 6h-3v-4h3Zm0 -6h-3v-4h3Zm5 5a1 1 0 0 1 -1 1h-2v-4h3Zm0 -5h-3v-4h3Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgData);
export default ForwardRef;